import { useCallback, useMemo, useState } from 'react';
import { QuyenChungTu } from '@/types/schemas';

export interface FormFieldState {
  quyenChungTu: QuyenChungTu | null;
  soChungTu: string;
  tyGia: number;
}

export interface FormFieldActions {
  setQuyenChungTu: (quyenChungTu: QuyenChungTu) => void;
  setSoChungTu: (soChungTu: string) => void;
  setTyGia: (tyGia: number) => void;
}

export interface UseFormFieldStateReturn {
  state: FormFieldState;
  actions: FormFieldActions;
}

const initialState: FormFieldState = {
  quyenChungTu: null,
  soChungTu: '',
  tyGia: 1
};

function transformInitialData(initialData?: MuaHangRecord): Partial<FormFieldState> {
  if (!initialData) return {};

  return {
    quyenChungTu: initialData.so_ct_data || null,
    soChungTu: initialData.so_ct || ''
  };
}

export function useFormFieldState(initialData?: MuaHangRecord): UseFormFieldStateReturn {
  const [state, setState] = useState<FormFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const setQuyenChungTu = useCallback((quyenChungTu: QuyenChungTu) => {
    setState(prev => ({
      ...prev,
      quyenChungTu
    }));
  }, []);

  const setSoChungTu = useCallback((soChungTu: string) => {
    setState(prev => ({ ...prev, soChungTu }));
  }, []);

  const setTyGia = useCallback((tyGia: number) => {
    setState(prev => ({ ...prev, tyGia }));
  }, []);

  const actions: FormFieldActions = useMemo(
    () => ({
      setQuyenChungTu,
      setSoChungTu,
      setTyGia
    }),
    [setQuyenChungTu, setSoChungTu, setTyGia]
  );

  return { state, actions };
}
